document.addEventListener('DOMContentLoaded', function() {
    const selectMenus = document.querySelectorAll('.wp-block-woodstock-police-addons-select-menu');

    selectMenus.forEach(select => {
        select.addEventListener('change', function(e) {
            const selectedUrl = e.target.value;
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        });
    });
});
